/** Merchant-name normalization and category tagging. */

import { CANONICAL, CATEGORIES, PREFIXES } from './data';

export interface Merchant {
  /** Stable grouping key. */
  key: string;
  /** Human-readable display name. */
  display: string;
}

/** Reduce a raw bank description to a stable merchant key + display name. */
export function merchant(description: string): Merchant {
  let s = description.trim();
  for (const p of PREFIXES) s = s.replace(p, '');

  // Strip reference codes, store numbers, phone numbers, dates.
  s = s.replace(/\b\d{2}\/\d{2}(\/\d{2,4})?\b/g, ' ');
  s = s.replace(/\b(ref|id|txn|auth|conf)[#:\s]*[a-z0-9-]{4,}\b/gi, ' ');
  s = s.replace(/#\s*\d+\b/g, ' '); // store numbers anywhere
  s = s.replace(/\b\d{3}-[a-z0-9-]{4,}\b/gi, ' '); // phone numbers incl. vanity (800-COMCAST)
  s = s.replace(/\b\d{5,}\b/g, ' ');
  s = s.replace(/\b\d{3,4}\b\s*$/g, ' ');
  s = s.replace(/\b[A-Z]{2}\s*$/g, ' '); // trailing state code
  s = s.replace(/\bhttps?:\/\/\S+/gi, ' ');
  s = s.replace(/[*_|]+/g, ' ');
  s = s.replace(/\s{2,}/g, ' ').trim();

  for (const [re, name] of CANONICAL) {
    if (re.test(description) || re.test(s)) return { key: name.toLowerCase(), display: name };
  }

  // Drop a trailing city-ish token when 3+ words remain.
  const words = s.split(' ');
  if (words.length >= 3 && /^[a-z]+$/i.test(words[words.length - 1]!)) words.pop();
  s = words.join(' ');

  const key = s.toLowerCase().replace(/[^a-z0-9+ ]/g, '').replace(/\s+/g, ' ').trim();
  const display = s.replace(/\w\S*/g, (w) => (/[a-z]/.test(w) ? w : w.charAt(0) + w.slice(1).toLowerCase()));
  return { key: key || description.toLowerCase(), display: display || description };
}

export function category(displayName: string, rawDescription: string): string {
  for (const [re, cat] of CATEGORIES) {
    if (re.test(displayName) || re.test(rawDescription)) return cat;
  }
  return 'Other';
}
